import styled from '@emotion/styled'

export const DescriptionForm = styled.span`
  font-size: 12px;
`
